<div class="mb-16 mt-3 flex items-center lg:mb-5" *ngIf="ticketResponse; else loading">
    <form ngNoForm method="post" action="{{ ticketResponse.url }}">
        <input type="hidden" name="ticket" value="{{ ticketResponse.ticketId }}" />
        <button class="btn-secondary mr-16 w-32 lg:w-64" tabindex="0" type="submit">
            {{ 'BTN_REGISTER' | translate }}
        </button>
    </form>
</div>
<ng-template #loading>
    <div class="my-4 flex justify-center" *ngIf="!ticketError">
        <mat-spinner [diameter]="50"></mat-spinner>
    </div>
</ng-template>
